/// <reference path="../include.ts" />

namespace project_guide {

	import DeployMode = project_common.DeployMode;

	export class Config {

		public static readonly deployMode = DeployMode.release;





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}
	}
}
